import { useEffect, useState } from 'react';
import { condividiReport } from '../lib/condivisione';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { fetchAnalyzedList, togglePreferito } from '../lib/api';
import ProspectCard from '../components/ProspectCard';
import { openMapAroundMe } from '../lib/geo';

const FONT = 'Manrope, system-ui, sans-serif';

const VERDETTO = {
  eccezionale: { label: 'Eccezionale', color: '#16a34a' },
  consigliata: { label: 'Consigliata', color: '#65a30d' },
  con_riserva: { label: 'Con riserva', color: '#d97706' },
  da_evitare:  { label: 'Da evitare',  color: '#dc2626' },
};
const euro = (v) => { try { return '€ ' + new Intl.NumberFormat('it-IT').format(v); } catch { return '€ ' + v; } };
const fmtDate = (s) => { try { return new Date(s).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' }); } catch { return ''; } };

export default function ProspectAnalyzed() {
  const navigate = useNavigate();
  const ctx = useOutletContext?.() || {};
  const toggleSidebar = ctx.toggleSidebar;
  const [list, setList] = useState(null); // null = loading
  const [reportUrl, setReportUrl] = useState(null);

  useEffect(() => { fetchAnalyzedList().then(setList).catch(() => setList([])); }, []);

  const handleToggleFav = (row) => {
    const flip = (l) => l ? l.map((x) => x.id === row.id ? { ...x, preferito: !x.preferito } : x) : l;
    setList(flip);
    togglePreferito(row.id).catch(() => setList(flip));
  };

  return (
    <div style={{ flex: 1, minHeight: 0, height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch', background: '#F6F7F9', fontFamily: FONT }}>
      {/* header */}
      <div style={{
        background: 'linear-gradient(160deg, #0E7A4E 0%, #16915E 55%, #12805A 100%)',
        display: 'none',
      }} />
      <div style={{ padding: 'calc(20px + env(safe-area-inset-top, 0px)) 18px 8px' }}>
        <div style={{ fontSize: 24, fontWeight: 900, color: '#1F2937', letterSpacing: '-0.02em' }}>Analizzati</div>
        <div style={{ fontSize: 13.5, color: '#6B7280', marginTop: 4 }}>Le analisi che hai sbloccato, dalla più recente</div>
      </div>

      <div style={{ padding: '10px 18px calc(96px + env(safe-area-inset-bottom, 0px))' }}>
        {list === null && <div style={{ color: '#9AA0A6', fontSize: 14 }}>Caricamento…</div>}

        {Array.isArray(list) && list.length === 0 && (
          <div style={{ background: '#fff', borderRadius: 18, padding: '30px 20px', textAlign: 'center', border: '1px dashed #D9DEE3', marginTop: 8 }}>
            <div style={{ fontSize: 34, marginBottom: 8 }}>🔍</div>
            <div style={{ fontWeight: 800, color: '#1F2937', marginBottom: 4 }}>Nessuna analisi ancora</div>
            <div style={{ color: '#6B7280', fontSize: 13.5, lineHeight: 1.45, marginBottom: 16 }}>
              Analizza un immobile dalla mappa: comparirà qui col suo verdetto.
            </div>
            <button onClick={() => navigate('/app/mappa')} style={{
              border: 0, background: '#1F6FEB', color: '#fff', borderRadius: 12, padding: '12px 22px', fontWeight: 800, fontSize: 14.5, cursor: 'pointer',
            }}>Vai alla mappa</button>
          </div>
        )}

        {Array.isArray(list) && list.map((r) => {
          const pending = !r.verdetto && (r.job_status === 'queued' || r.job_status === 'running');
          return (
            <div key={r.id} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, padding: '0 2px' }}>
                {pending && (
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#EAF2FF', color: '#2563EB', borderRadius: 999, padding: '3px 10px', fontSize: 12, fontWeight: 800 }}>
                    <span style={{ width: 10, height: 10, borderRadius: '50%', border: '2px solid rgba(37,99,235,0.35)', borderTopColor: '#2563EB', display: 'inline-block', animation: 'anSpin .8s linear infinite' }} />
                    <style>{'@keyframes anSpin{to{transform:rotate(360deg)}}'}</style>
                    In analisi
                  </span>
                )}
                <span style={{ marginLeft: 'auto', fontSize: 11.5, color: '#9AA0A6', fontWeight: 700 }}>Sbloccata il {fmtDate(r.unlocked_at)}</span>
              </div>
              {/* Sempre ProspectCard: se non c'è verdetto ma il job è attivo mostra
                  da sé lo stato "Analisi in corso" (box grigio + barra + spinner). */}
              <ProspectCard
                row={r}
                analyzed={!!(r.verdetto || r.rivelasta_verdetto)}
                onOpen={() => navigate(`/app/mappa?focus=${r.id}`)}
                onReport={(url) => setReportUrl(url)}
                onShare={(row, btn) => condividiReport(row, btn)}
                onToggleFav={handleToggleFav}
              />
            </div>
          );
        })}
      </div>

      {/* Bottom tab bar */}
      <nav style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 60,
        display: 'flex', background: '#fff', borderTop: '1px solid #ECEDEF',
        boxShadow: '0 -2px 12px rgba(0,0,0,0.06)', paddingBottom: 'env(safe-area-inset-bottom, 0px)', fontFamily: FONT,
      }}>
        {[
          { id: 'cerca', label: 'Cerca', onClick: () => navigate('/app/home'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke={c} strokeWidth="1.9"/><path d="M21 21l-4.3-4.3" stroke={c} strokeWidth="1.9" strokeLinecap="round"/></svg>) },
          { id: 'mappa', label: 'Mappa', onClick: () => openMapAroundMe(navigate),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11Z" stroke={c} strokeWidth="1.8" strokeLinejoin="round"/><circle cx="12" cy="10" r="2.4" stroke={c} strokeWidth="1.8"/></svg>) },
          { id: 'preferiti', label: 'Preferiti', onClick: () => navigate('/app/mappa?view=preferiti'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M12 21s-7-4.35-9.5-8.5C1 9.5 2.5 5.5 6.5 5.5c2 0 3.5 1.5 5.5 3.5 2-2 3.5-3.5 5.5-3.5 4 0 5.5 4 4 7C19 16.65 12 21 12 21z" stroke={c} strokeWidth="1.8" strokeLinejoin="round"/></svg>) },
          { id: 'analizzati', label: 'Analizzati', active: true, onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M4 5h16M4 12h16M4 19h10" stroke={c} strokeWidth="1.8" strokeLinecap="round"/><circle cx="19.5" cy="18.5" r="3" stroke={c} strokeWidth="1.8"/><path d="M21.7 20.7L23 22" stroke={c} strokeWidth="1.8" strokeLinecap="round"/></svg>) },
          { id: 'profilo', label: 'Profilo', onClick: () => navigate('/app/profilo'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke={c} strokeWidth="1.8"/><path d="M4 20c0-4 3.6-6 8-6s8 2 8 6" stroke={c} strokeWidth="1.8" strokeLinecap="round"/></svg>) },
        ].map((t) => {
          const col = t.active ? '#1F6FEB' : '#9AA0A6';
          return (
            <button key={t.id} onClick={t.onClick} style={{
              flex: 1, border: 0, background: 'transparent', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '9px 0 8px', color: col,
            }}>
              {t.icon(col)}
              <span style={{ fontSize: 11, fontWeight: t.active ? 700 : 600, letterSpacing: '-0.01em' }}>{t.label}</span>
            </button>
          );
        })}
      </nav>

      {reportUrl && (
        <div className="pr-report-modal" role="dialog" aria-label="Report analisi AI">
          <div className="pr-report-modal__backdrop" onClick={() => setReportUrl(null)} />
          {/* ✕ figlia del contenitore (fixed), NON dello sheet: sta nella fascia
              sopra il modale e non si sovrappone al verdetto. */}
          <button type="button" className="pr-report-modal__close" onClick={() => setReportUrl(null)} aria-label="Chiudi">×</button>
          <div className="pr-report-modal__sheet">
            <iframe className="pr-report-modal__iframe" src={reportUrl} title="Analisi immobile" />
          </div>
        </div>
      )}
    </div>
  );
}
